import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryFormCustomFieldConditions`

export default defineMessages({
  fieldLabel: {
    id: `${scope}.fieldLabel`,
    defaultMessage: 'Custom field #{number}',
  },
  fieldHint: {
    id: `${scope}.fieldHint`,
    defaultMessage: '(Only applies to dropdown and checkbox fields)',
  },
  valuesLabel: {
    id: `${scope}.valuesLabel`,
    defaultMessage: 'Is any of these options',
  },
  valuesRequiredError: {
    id: `${scope}.valuesRequiredError`,
    defaultMessage: 'Select at least one option',
  },
  warning: {
    id: `${scope}.warning`,
    defaultMessage:
      "Custom field filters don't apply to expense claims or spend card transactions, so those won't count toward this budget.",
  },
})
